export default "__VITE_ASSET__674dc613__"